const table = {
  defaultProps: {
    colorScheme: 'brand.secondary',
  },
}

export default table
